import { api } from "@/lib/api";

/** Opens an authenticated file (PDF/PNG) from the API in a new tab. */
export async function openAuthedFile(path) {
  const win = window.open("", "_blank");
  try {
    const r = await api.get(path, { responseType: "blob" });
    const url = URL.createObjectURL(r.data);
    if (win) win.location.href = url;
    else window.location.href = url;
    setTimeout(() => URL.revokeObjectURL(url), 60_000);
  } catch (e) {
    if (win) win.close();
    throw e;
  }
}
